import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SuiteType.css";

const API_URL = "https://apipurple.topranohotelandlounge.com/api/suite-types";
// const HOTEL_ID = "HTL123"; // 🔥 replace with dynamic value if needed

function SuiteTypeManagement() {
  const [suiteTypes, setSuiteTypes] = useState([]);
  const [hotelId, setHotelId] = useState("purple-crown");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    basePrice: "",
    capacity: "",
    size: "",
    images: "",
    totalRooms: "",
    amenities: ""
  });

  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");

const fetchSuiteTypes = async () => {
  try {
    const res = await axios.get(`${API_URL}/${hotelId}`);
    setSuiteTypes(res.data.data || []);
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  fetchSuiteTypes();
}, [hotelId]);
  // ✅ Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // ✅ Create or Update

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    let payload = {
      ...formData,
      images: formData.images ? formData.images.split(",") : [],
      amenities: formData.amenities ? formData.amenities.split(",") : []
    };

    Object.keys(payload).forEach(
      (key) => payload[key] === "" && delete payload[key]
    );

    if (editingId) {
      // ✅ UPDATE (FIXED)
      await axios.put(`${API_URL}/${hotelId}/${editingId}`, payload);
      setMessage("Updated successfully!");
    } else {
      // ✅ CREATE
      await axios.post(`${API_URL}/${hotelId}/suite-types`, payload);
      setMessage("Created successfully!");
    }

    setFormData({
      name: "",
      description: "",
      basePrice: "",
      capacity: "",
      size: "",
      images: "",
      totalRooms: "",
      amenities: ""
    });

    setEditingId(null);
    fetchSuiteTypes();

  } catch (err) {
    console.error(err);
    setMessage("Error occurred");
  }
};
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       let payload = {
//         ...formData,
//         images: formData.images ? formData.images.split(",") : [],
//         amenities: formData.amenities ? formData.amenities.split(",") : []
//       };

//       // Remove empty fields (🔥 allows partial update)
//       Object.keys(payload).forEach(
//         (key) => payload[key] === "" && delete payload[key]
//       );

//       if (editingId) {
//         // UPDATE
//         // await axios.patch(`${API_URL}/${hotelId}/${editingId}`, payload);
//         await axios.patch(`${API_URL}/${hotelId}/suite-types/${editingId}`, payload);
//         setMessage("Updated successfully!");
//       } else {
//         // CREATE
//         await axios.post(`${API_URL}/${hotelId}`, payload);
//         setMessage("Created successfully!");
//       }

//       setFormData({
//         name: "",
//         description: "",
//         basePrice: "",
//         capacity: "",
//         size: "",
//         images: "",
//         totalRooms: "",
//         amenities: ""
//       });

//       setEditingId(null);
//       fetchSuiteTypes();
//     } catch (err) {
//       console.error(err);
//       setMessage("Error occurred");
//     }
//   };

  // ✅ Edit button
  const handleEdit = (suite) => {
    setEditingId(suite._id);
    setFormData({
      ...suite,
      images: suite.images?.join(",") || "",
      amenities: suite.amenities?.join(",") || ""
    });
  };

  return (
    <div className="suite-container">
      <h2>Suite Management</h2>
      <div className="hotel-selector">
  <label>Select Hotel:</label>
  <select value={hotelId} onChange={(e) => setHotelId(e.target.value)}>
    <option value="purple-crown">Purple Crown</option>
    <option value="purple-crown-gold">Purple Crown Gold</option>
  </select>
</div>

      {message && <p className="message">{message}</p>}

      {/* FORM */}
      <form onSubmit={handleSubmit} className="suite-form">
        <input name="name" placeholder="Name" value={formData.name} onChange={handleChange} />
        <input name="description" placeholder="Description" value={formData.description} onChange={handleChange} />
        <input name="basePrice" placeholder="Price" value={formData.basePrice} onChange={handleChange} />
        <input name="capacity" placeholder="Capacity" value={formData.capacity} onChange={handleChange} />
        <input name="size" placeholder="Size" value={formData.size} onChange={handleChange} />
        <input name="totalRooms" placeholder="Total Rooms" value={formData.totalRooms} onChange={handleChange} />
        <input name="images" placeholder="Images (comma separated)" value={formData.images} onChange={handleChange} />
        <input name="amenities" placeholder="Amenities (comma separated)" value={formData.amenities} onChange={handleChange} />

        <button type="submit">
          {editingId ? "Update Suite" : "Create Suite"}
        </button>
      </form>

      {/* LIST */}
      <div className="suite-list">
        {suiteTypes.map((suite) => (
          <div key={suite._id} className="suite-card">
            <h3>{suite.name}</h3>
            <p>₦{suite.basePrice}</p>
            <p>{suite.capacity} persons</p>

            <button onClick={() => handleEdit(suite)}>Edit</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SuiteTypeManagement;